import React from 'react';
import styled from 'styled-components';
import {PrimaryRaisedButton} from '../buttons/index';


const AddToFavorites = ({label, addToFavorites, patternid, query}) => {

    const StyledWrapper = styled.div`
        text-align: right;

        & button {
            margin: 0px;
        }
    `;

    const handleClick = () => {
        addToFavorites(patternid, query);
    };

    return (
        <StyledWrapper>
            <PrimaryRaisedButton icon="heartadd" text={label} handleClick={handleClick}/>
        </StyledWrapper>
    );
};

export default AddToFavorites;



// WEBPACK FOOTER //
// ./src/components/pattern/AddToFavorites.js